import { render, staticRenderFns } from "./cards.vue?vue&type=template&id=0bffe6e3&scoped=true"
import script from "./cards.vue?vue&type=script&lang=js"
export * from "./cards.vue?vue&type=script&lang=js"
import style0 from "./cards.vue?vue&type=style&index=0&id=0bffe6e3&prod&scoped=true&lang=css"
import style1 from "./cards.vue?vue&type=style&index=1&id=0bffe6e3&prod&lang=css"
import style2 from "./cards.vue?vue&type=style&index=2&id=0bffe6e3&prod&lang=css"
import style3 from "./cards.vue?vue&type=style&index=3&id=0bffe6e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffe6e3",
  null
  
)

export default component.exports